import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import axios from 'axios';
import Utils from '@this/domain/appoint/utils';
import { useHistory } from 'react-router-dom';
import SignInupForm from './sign_inup_form';

interface Response {
  google_oauth_path: string;
  outlook_oauth_path: string;
}

const UsersSignIn = observer(() => {
  const history = useHistory();
  const [googleOauthPath, setGoogleOauthPath] = useState<string>('');
  const [outlookOauthPath, setOutlookOauthPath] = useState<string>('');

  const fetchData = async () => {
    const response = await axios.get<Response>(history.createHref({ pathname: '/users/sign_in.json' }));
    setGoogleOauthPath(response.data.google_oauth_path);
    setOutlookOauthPath(response.data.outlook_oauth_path);
  };

  // マウント時に1回発動
  useEffect(() => {
    Utils.trackEvent('[cal][view] sign in');
    fetchData();
  }, []);

  return <SignInupForm googleOauthPath={googleOauthPath} outlookOauthPath={outlookOauthPath} />;
});

export default UsersSignIn;
